import { render } from "./CalendarEventMeetingTypesListItem.vue?vue&type=template&id=066ce941&scoped=true"
import script from "./CalendarEventMeetingTypesListItem.vue?vue&type=script&lang=ts"
export * from "./CalendarEventMeetingTypesListItem.vue?vue&type=script&lang=ts"

import "./CalendarEventMeetingTypesListItem.vue?vue&type=style&index=0&id=066ce941&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-066ce941"

export default script